import React from 'react';

import { useCurrentNewsletter, useCurrentNewsletterSubscription } from '@hooks';

import Footer from './Footer';
import Header from './Header';
import Middle from './Middle';

const HEADER = 'header';
const MIDDLE = 'middle';
const FOOTER = 'footer';

interface ContentProps {
  currentUserAccessLevel: number;
  feedType: string;
  gdpr: boolean;
  gdprColorScheme: string;
  isLoggedIn: boolean;
  newsletterId: number;
}

const Content = ({
  currentUserAccessLevel,
  isLoggedIn,
  newsletterId,
  feedType,
  gdpr,
  gdprColorScheme,
}: ContentProps) => {
  const { isSubscribed } = useCurrentNewsletterSubscription(newsletterId);
  const { newsletter } = useCurrentNewsletter(newsletterId);

  if (!newsletter) {
    return null;
  }

  const renderFeed = () => {
    switch (feedType) {
      case HEADER:
        return (
          <Header
            currentUserAccessLevel={currentUserAccessLevel}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
            newsletter={newsletter}
          />
        );
      case MIDDLE:
        return (
          <Middle
            currentUserAccessLevel={currentUserAccessLevel}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
            newsletter={newsletter}
          />
        );
      case FOOTER:
        return (
          <Footer
            currentUserAccessLevel={currentUserAccessLevel}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
            newsletter={newsletter}
          />
        );
      default:
        console.error('Unknown Feed Type');
    }
  };
  return renderFeed();
};

export default Content;
